
  <div class="alert alert-info">
    <icon name="circle-o-notch spin"></icon> {{ message }}
  </div>
  